import type { Offer } from "types/offer"
import type { IProduct } from "@/types"

export const createCartItem = (product: IProduct, offer: Offer, isWorkshop: boolean) => {
  const titleImage = product.images?.find((image) => image?.isTitle)

  return {
    fullName: product.fullName,
    ...(titleImage
      ? {
          image: {
            url: titleImage?.url ?? "",
            name: titleImage?.name ?? "",
          },
        }
      : {}),
    price: {
      value: offer.price.value,
      currencyIso: offer.price.currencyIso,
    },
    priceId: offer.id,
    quantity: 1,
    ready2Order: true,
    sku: product.sku,
    totalPrice: {
      value: offer.price.value,
      currencyIso: offer.price.currencyIso,
    },
    ...(isWorkshop ? { isWorkshop } : {}),
  }
}
